// /wp-content/uploads/2024/06/whatsapp-boton-a.png

const openFullscreen = $e => {

  const e = $e[0]

  if(!document.fullscreenElement) {

    if (e.requestFullscreen) {
      e.requestFullscreen();
    } else if (e.webkitRequestFullscreen) {
      e.webkitRequestFullscreen();
    } else if (e.msRequestFullscreen) {
      e.msRequestFullscreen();
    }
     
  } else if(document.fullscreenElement == e){

    document.exitFullscreen()
  }  
}

export default $ => {  

  const $trikavideosinspiration = $('.wp-block-vicenmontserrat-trikavideosinspiration')

  if($trikavideosinspiration.length) {

    $('body').addClass('TrikaVideosInspiration')
    $('#whatsappbutton').hide()

    const $settings = $trikavideosinspiration.find('.HiddenSettings')
    const settingscontent = $settings.html()
    .split('«').join('"')
    .split('»').join('"')
    .split('″').join('"')
    const settings = JSON.parse(settingscontent)

    const $files = $trikavideosinspiration.find('.HiddenFiles')
    const filescontent = $files.html()
    .split('«').join('"')
    .split('»').join('"')
    .split('″').join('"')
    .split('×').join('x')
    const files = JSON.parse(filescontent)
    
    const $texts = $trikavideosinspiration.find('.HiddenTexts')
    const textscontent = $texts.html()
    .split('«').join('"')
    .split('»').join('"')
    .split('″').join('"')
    const texts = JSON.parse(textscontent)

    const slides = []
    texts.forEach(
      text => {

        files.forEach(
          file => {

            slides.push({
              file: file,
              text: text
            })
          }
        )
      }
    )

    const $media = $trikavideosinspiration.find('.Media')
    const $sentenceauthor = $trikavideosinspiration.find('.Texts')
    const $sentence = $sentenceauthor.find('.Sentence')    
    const $author = $sentenceauthor.find('.Author')
    const $logo = $trikavideosinspiration.find('.Logo')
    const $logoimg = $logo.find('img')
    const $start = $trikavideosinspiration.find('.Start')

    $logoimg.attr('src', settings.logoimage)
    $sentence.css('color', settings.textcolor)
    $author.css('color', settings.textcolor)
    
    const duration = settings.slideduration * 1000
    let actualslide = 0
    const showslide = () => {

      const slide = slides[actualslide]
      const file = slide.file
      const sentence = slide.text.sentence.split('<br>')
      const author = slide.text.author

      $sentence.fadeOut(800)
      $author.fadeOut(800)
      $media.fadeOut(
        1000,
        () => {

          $media.empty()
          $sentence.html('')
          $author.hide()
          $author.html(author)

          if(file.type != 'video/mp4') {

            $media.append(`
              <div 
                class="Image"
                style="background-image: url(${ file.thumb })"
              ></div>
            `)
          } else {

            $media.append(`
              <video 
                preload="metadata" 
                autoplay 
                loop="true"
              >
                  <source 
                    src="${ file.guid }" 
                    type="video/mp4"
                  ></source>
                </video>
            `)
          }

          $sentence.fadeIn(500)
          $media.fadeIn(
            1000,
            () => {

              $sentence.teletype({
                text: sentence,
                delay: 80,
                end: () => {    

                  $author.fadeIn(
                    1000,
                    () => {

                      actualslide++
                      if(actualslide > slides.length - 1) { actualslide = 0 }
                      setTimeout(
                        showslide,
                        duration
                      )
                    }
                  )
                }
              })       
            }
          )
        }
      )      
    }

    $logo
    .on(
      'click',
      function() {

        openFullscreen($trikavideosinspiration)
      }
    )    

    $start
    .on(
      'click',
      function() {

        $start
        .fadeOut(
          1000,
          () => {

            showslide()
          }
        )
      }
    )

    /* DEBUG

    $sentenceauthor
    .on(
      'click',
      function() {

        $start
        .fadeOut(100)

        actualslide++
        if(actualslide > slides.length - 1) { actualslide = 0 }
        showslide()
      }
    )
    
    $start.hide()
    showslide()
    
    */
  }
}